import { render } from "./PortfolioProjectWatch.vue?vue&type=template&id=71221258"
import script from "./PortfolioProjectWatch.vue?vue&type=script&lang=js"
export * from "./PortfolioProjectWatch.vue?vue&type=script&lang=js"

import "./PortfolioProjectWatch.vue?vue&type=style&index=0&id=71221258&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__